import generateCredentialBase64A4Normal from "../../../helpers/generateCredentialBase64A4Normal";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import downloadUrl from "../../../helpers/downloadUrl";
import { getBackgroundColor, viewFileByUrl } from "../../../utils/functions";
import FOTO_DEFAULT from "../../../assets/user_icon.png";
import { useState } from "react";

export default function CredencialButton({ user }) {
  const [downloadingCredencial, setDownloadingCredencial] = useState(false);

  console.log("user", user);

  const userCredential = {
    nombre: user.nombre,
    apellido: user.apellido,
    correlativo: user.correlativo,
    nrodocumento: user.nrodocumento,
    tipoparticipacion: user.tipoparticipacion,
    tipoparticipante: user.tipoparticipante,
    color: getBackgroundColor[user.color] || "CIAN",
    fotoParticipante: viewFileByUrl("foto_rostro", user.nrodocumento + "-FOT.jpg") || FOTO_DEFAULT
  };

  const downloadCredential = async (user = {}) => {
    try {
      setDownloadingCredencial(true);
      const credentialBase64 = await generateCredential(user);
      downloadUrl(credentialBase64, `${user.nrodocumento}-CREDENCIAL.pdf`);
      setDownloadingCredencial(false);
    } catch (error) {
      console.log(error);
    }
  };

  const generateCredential = (user = {}) => {
    return new Promise((resolve, reject) => {
      const credential = generateCredentialBase64A4Normal(user);
      resolve(credential);
    });
  };

  return (
    <div className="m-auto relative">
      <Button
        className="mb-3"
        type="primary"
        loading={downloadingCredencial}
        icon={<DownloadOutlined />}
        onClick={() => downloadCredential(userCredential)}
      >
        Descargar credencial
      </Button>
    </div>
  );
}
